export default __webpack_public_path__ + "static/media/ska.3fe228c1.png";